<template>
  <VList density="compact" nav>
    <template v-if="isRailModelValue">
      <div v-for="(item, index) in sideBarList" :key="`side-${index}`">
        <VListItem
          v-if="!('children' in item)"
          :title="item.title"
          :prependIcon="item.icon"
          :value="item.value"
          activeClass="active-item"
          :to="item.link"
        >
          <VTooltip activator="parent" location="start">
            {{ item.title }}
          </VTooltip>
        </VListItem>

        <VListItem
          v-else
          :title="item.title"
          :prependIcon="item.icon"
          :value="item.value"
          activeClass="active-item"
          :to="item.link"
          @click="toggleTooltip(index)"
        >
          <VTooltip
            v-model="tooltips[index]"
            activator="parent"
            location="start"
          >
            <template #default>
              <VListItem
                v-for="(child, _index) in item.children"
                :key="`child-${_index}`"
                :title="child.title"
                :value="child.value"
                :to="child.link"
                class="text-start ms-2"
              >
                <template #prepend>
                  <VIcon icon="dot" size=".5rem" />
                </template>
              </VListItem>
            </template>
          </VTooltip>
        </VListItem>
      </div>
    </template>

    <template v-else>
      <div v-for="(item, index) in sideBarList" :key="`side-${index}`">
        <VListItem
          v-if="!('children' in item) || isRailModelValue"
          :title="item.title"
          :prependIcon="item.icon"
          :value="item.value"
          :to="item.link"
        />

        <VListGroup v-else :value="item.value" :isOpen="!isRailModelValue">
          <template #activator="{ props, isOpen }">
            <VListItem
              v-bind="props"
              :prependIcon="item.icon"
              :title="item.title"
              :activeClass="isOpen ? 'active-item' : ''"
              :elevation="0"
            />
          </template>

          <div class="border-s ms-4">
            <VListItem
              v-for="(child, _index) in item.children"
              :key="`child-${_index}`"
              :title="child.title"
              :value="child.value"
              :to="child.link"
              class="text-start ms-2"
            >
              <template #prepend>
                <VIcon icon="dot" size=".5rem" />
              </template>
            </VListItem>
          </div>
        </VListGroup>
      </div>
    </template>
  </VList>
</template>

<script lang="ts" setup>
import {
  VIcon,
  VList,
  VListGroup,
  VListItem,
  VTooltip,
} from 'vuetify/components'
import { ref } from 'vue'
import type { Props, Emits } from './TheSideBarList.types'
import { useSideBar } from '@/modules/Core/composables'

defineProps<Props>()
defineEmits<Emits>()

const isRailModelValue = defineModel<boolean>('rail')

const { sideBarList } = useSideBar()

const tooltips = ref<Record<number, boolean>>({})

function toggleTooltip(index: number) {
  tooltips.value[index] = !tooltips.value[index]
}
</script>

<style scoped>
:deep(.v-list-item--active) {
  .v-list-item__prepend,
  .v-list-item-title {
    color: rgb(var(--v-theme-primary)) !important;
  }
}

.active-item {
  background-color: rgba(var(--v-theme-gray-600), 0.08) !important;
}
.v-list-group__items .v-list-item {
  padding-inline-start: 1.2rem !important;
}
</style>
